import { createClient } from "@supabase/supabase-js";

import { Database } from "./schema";

export const projectURL = import.meta.env.VITE_SUPABASE_PROJECT_URL;
const projectKey = import.meta.env.VITE_SUPABASE_PROJECT_KEY;

export const supabase = createClient<Database>(projectURL, projectKey);
